import styled from 'styled-components'

const StyledSVG = styled.svg`
  path {
    fill: ${({ theme, color }) => theme.colors[color]};
  }
`
const InfoIcon = ({ dataTestid, color = 'primary' }) => {
  return (
    <StyledSVG width="37" height="36" viewBox="0 0 37 36" fill="none">
      <g clipPath="url(#clip0_3761_2500)">
        <path
          d="M18.5002 33C27.0146 33 33.9168 26.2843 33.9168 18C33.9168 9.71573 27.0146 3 18.5002 3C9.98577 3 3.0835 9.71573 3.0835 18C3.0835 26.2843 9.98577 33 18.5002 33Z"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5 24V18"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5 12H18.5154"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3761_2500">
          <rect width="37" height="36" fill="white" />
        </clipPath>
      </defs>
    </StyledSVG>
  )
}

export default InfoIcon
